<template>
  <div>
    <section class="con1">
      <div class="container inner">
        <img
          src="@/assets/img/centerone/con1/bg-m.png"
          alt="img"
          class="bg-m"
        />
        <img
          src="@/assets/img/centerone/con1/bg-pc.png"
          alt="img"
          class="bg-pc"
        />
        <div class="main-img">
          <img src="@/assets/img/centerone/con1/main.png" alt="img" />
        </div>
        <div class="text-img">
          <img src="@/assets/img/centerone/con1/text.png" alt="img" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
section {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

// con1
.con1 {
  background-color: #f7f2ec;
  overflow: hidden;

  @media screen and (min-width: 1200px) {
    display: flex;
    justify-content: center;
  }

  .inner {
    position: relative;
    padding: 0 18px;

    @media screen and (min-width: 1200px) {
      padding: 0;
      max-width: 1730px;
      min-width: 1730px;
    }

    .bg-m {
      @media screen and (min-width: 1200px) {
        display: none;
      }
    }

    .bg-pc {
      display: none;

      @media screen and (min-width: 1200px) {
        display: block;
      }
    }

    .main-img {
      position: absolute;
      top: 34%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      padding: 0 52px;

      @media screen and (min-width: 1200px) {
        top: 174px;
        left: 0;
        transform: translateY(0);
        padding: 0;
      }

      img {
        width: 100%;
        max-width: 280px;
        margin: 0 auto;
        animation: fade 6s;

        @media screen and (min-width: 768px) {
          max-width: 400px;
        }

        @media screen and (min-width: 1024px) {
          max-width: 500px;
        }

        @media screen and (min-width: 1200px) {
          width: 462px;
        }
      }
    }

    .text-img {
      position: absolute;
      bottom: 18px;
      left: 50%;
      transform: translateX(-50%);
      width: 106px;

      @media screen and (min-width: 1200px) {
        bottom: 42px;
        left: unset;
        transform: translateX(0);
        right: 264px;
        width: 178px;
      }
    }
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
